import React, { useEffect, Suspense } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { initAPIClient } from '../services/API';
import { app, analytics } from '../config/firebase';

import styles from './index.module.css';

// import LoadingPage from '../page/Loading';
const HomePage = React.lazy(() => import("../page/Home"));
const RedeemPage = React.lazy(() => import("../page/Redeem"));
const FAQPage = React.lazy(() => import("../page/FAQ"));
const CompatibilityPage = React.lazy(() => import("../page/Compatibility"));
const OrderSummaryPage = React.lazy(() => import("../page/OrderSummary"));
const PaymentPage = React.lazy(() => import("../page/Payment"));
const PaymentSuccessPage = React.lazy(() => import("../page/PaymentSuccess"));
const PaymentFailedPage = React.lazy(() => import("../page/PaymentFailed"));
const TermsAndConditionsPage = React.lazy(() => import("../page/TermsAndConditions"));
const DataProtectionPage = React.lazy(() => import("../page/DataProtection"));

function AppContent() {
  const location = useLocation();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className={styles['page']} key={location.pathname}>
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/redeem" element={<RedeemPage />} />

          <Route path="/faq" element={<FAQPage />} />
          <Route path="/compatibility" element={<CompatibilityPage />} />
          <Route path="/order-summary" element={<OrderSummaryPage />} /> 
          {/* <Route path="/payment" element={<PaymentPage />} /> */}
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/payment-failed" element={<PaymentFailedPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
          <Route path="/data-protection" element={<DataProtectionPage />} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Suspense>
  );
}

function App(props) {
  useEffect(() => {
    // Initialize Firebase
    try {
      // Firebase app is already initialized in firebase.js
      if (analytics) {
        console.log('Firebase Analytics initialized');
      }
    } catch (error) {
      console.error('Failed to initialize Firebase:', error);
    }

    // Initialize API client with base URL
    const initializeAPI = async () => {
      try {
        await initAPIClient();
        console.log('API client initialized');
      } catch (error) {
        console.error('Failed to initialize API client:', error);
      }
    };
    initializeAPI();
    // return () => {
    // }
    /* eslint-disable */
  }, []);

  return (
    <div className={styles['wrapper']}>
      <AppContent />
    </div>
  );
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);
